import type { FaireProductEntity } from "../../entity_types/product";

export const p_pr79g4xq3u: FaireProductEntity = {
  token: "p_pr79g4xq3u",
  type: "product",
  name: "Grand Canyon 1000 Piece Jigsaw Puzzle",
  brandToken: "b_2rys9jdptm",
  brandName: "Toynk",
  imageUrl:
    "https://cdn.faire.com/fastly/eda7a923b607f63f2d5448e5a0526bffcb0b2f71f9909ab36b0f41680a6142f0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ebf98802f5b21b2aa037c0aa924a1dca619c36c5dfa20ffe43a4a1a185b505d7.jpeg",
    "https://cdn.faire.com/fastly/b1e82ca2ffc495b50728137e19080fd4313bf9c5264219c4ffb5f41e2f677678.jpeg",
  ],
  priceDollars: 13.86,
  description:
    "MasterPieces is an USA Arizona based Puzzle & Game Company. For over 25 years we’ve specialized in creating jigsaw puzzles for both children and adults. From new puzzlers to the avid puzzle enthusiasts, we design our puzzles using thick durable puzzle board to offer a higher quality puzzling experience. Our puzzles are environmentally friendly and designed with non-toxic soy-based inks. Jigsaw Puzzles make the perfect gift for anyone who enjoys a relaxing evening activity or a mind-bending challenge! The MasterPieces Kids collection offers a wide variety of puzzles with vibrant colors and unique themes and styles. The Right Fit Guide was developed with your little one in mind and is designed to help match the piece count and piece size to the age and skill level of the child. Enjoy piecing together wildlife, silly characters and images with hidden shapes and patterns to help little ones develop their cognitive skills and have fun! Our high-quality packaging will let you save, store, and enjoy puzzling time and time again. When you choose MasterPieces, quality isn’t just a promise..",
  tags: [],
  msrpDollars: 29.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:29.349Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
